/* eslint-disable max-len */
import { JsonObject, JsonProperty } from "typescript-json-serializer";

/**
 * A predicate function use to determine what is the
 * right type of domain
 */
// eslint-disable-next-line arrow-body-style
export const DomainType = (domain: any) => {
    return domain && domain.type === "coded-value"
        ? CodedValueDomainConfiguration
        : DomainConfiguration;
};

@JsonObject()
export class DomainConfiguration {
    /**
     * The domain name.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-support-Domain.html#name)
     */
    @JsonProperty()
    declare name: string;

    /**
     * The domain type.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-support-Domain.html#type)
     */
    @JsonProperty()
    declare type: "range" | "coded-value" | "inherited";

    /**
     * *Geo.js Property*
     * Beschreibung
     */
    declare description: string;

    constructor() {};

}

@JsonObject()
export class CodedValueDomainConfiguration extends DomainConfiguration {

    declare readonly type: "coded-value";

    /**
     * An array of the coded values in the domain.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-support-CodedValueDomain.html#codedValues)
     */
    @JsonProperty()
    declare codedValues: CodedValueConfiguration[];

    constructor() {
        super();
    };
}

@JsonObject()
export class CodedValueConfiguration {
    /**
     * The value of the code.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-support-CodedValueDomain.html#CodedValue)
     */
    @JsonProperty()
    declare code: string | number;
    /**
     * The name of the coded value.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-support-CodedValueDomain.html#CodedValue)
     */
    @JsonProperty()
    declare name: string;
}
